import { useState } from "react";
import PropTypes from "prop-types";
import MarketReportPresenceSelect from "./MarketReportPresenceSelect";
import LastViewedMarketReportSelect from "./LastViewedMarketReportSelect";

const MarketReportFilters = ({
  lastViewedMarketReportRangeOptions,
  previousSelectedReportPresence,
  previousSelectedRange,
}) => {
  const [isLastMarketReportDropdownDisabled, setIsLastMarketReportDropdownDisabled] = useState(false);

  return (
    <>
      <div className="tw-flex tw-gap-[16px]">
        <MarketReportPresenceSelect
          previousSelectedReportPresence={previousSelectedReportPresence}
          setIsLastMarketReportDropdownDisabled={setIsLastMarketReportDropdownDisabled}
        />
        <div id="filter-market_report_views" className="tw-flex-1">
          <LastViewedMarketReportSelect
            isDisabled={isLastMarketReportDropdownDisabled}
            lastViewedMarketReportRangeOptions={lastViewedMarketReportRangeOptions}
            previousSelectedRange={previousSelectedRange}
          />
        </div>
      </div>
      <hr />
    </>
  );
};

MarketReportFilters.propTypes = {
  lastViewedMarketReportRangeOptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  previousSelectedReportPresence: PropTypes.string.isRequired,
  previousSelectedRange: PropTypes.string.isRequired,
};

export default MarketReportFilters;
